export default "__VITE_ASSET__BaEmKu$b__"